var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraySeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4126_1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51562 17.9688C6.21594 17.9688 6.78125 17.4034 6.78125 16.7031V15.4375H15.2188V16.7031C15.2188 17.4034 15.7841 17.9688 16.4844 17.9688C17.1847 17.9688 17.75 17.4034 17.75 16.7031V14.5938C17.75 13.6656 16.9906 12.9062 16.0625 12.9062H5.9375C5.00937 12.9062 4.25 13.6656 4.25 14.5938V16.7031C4.25 17.4034 4.81531 17.9688 5.51562 17.9688ZM17.75 8.6875H18.5938C19.0578 8.6875 19.4375 9.06719 19.4375 9.53125V10.375C19.4375 10.8391 19.0578 11.2188 18.5938 11.2188H17.75C17.2859 11.2188 16.9062 10.8391 16.9062 10.375V9.53125C16.9062 9.06719 17.2859 8.6875 17.75 8.6875ZM3.40625 8.6875H4.25C4.71406 8.6875 5.09375 9.06719 5.09375 9.53125V10.375C5.09375 10.8391 4.71406 11.2188 4.25 11.2188H3.40625C2.94219 11.2188 2.5625 10.8391 2.5625 10.375V9.53125C2.5625 9.06719 2.94219 8.6875 3.40625 8.6875ZM15.2188 11.2188H6.78125V4.46875C6.78125 3.54062 7.54062 2.78125 8.46875 2.78125H13.5312C14.4594 2.78125 15.2188 3.54062 15.2188 4.46875V11.2188Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4126_1461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 20.25,
    fill: "white",
    transform: "translate(0.875 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySeat);
export default __webpack_public_path__ + "static/media/GraySeat.6ba60b54bbe2a36396333e980e316510.svg";
export { ForwardRef as ReactComponent };